import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { Img } from '#src/atoms/ui/Img/index.tsx';
import { TextWithLine } from '#src/atoms/ui/TextWithLine/index.tsx';
import { tabletAndAbove } from '#src/style/mediaQuery.ts';

import gpAvif from './assets/gerard-pique.avif';
import gp from './assets/gerard-pique.webp';
import kmAvif from './assets/kylian-mbappe.avif';
import km from './assets/kylian-mbappe.webp';
import rfAvif from './assets/rio-ferdinand.avif';
import rf from './assets/rio-ferdinand.webp';

const Pictures = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
  align-items: center;
  :nth-child(2) {
    /** mbappe comes first on mobile */
    order: -1;
  }
  @media ${tabletAndAbove} {
    flex-direction: row;
    justify-content: space-between;
    :nth-child(2) {
      /** mbappe stays in the middle on desktop */
      order: unset;
    }
  }
`;

const Image = styled(Img)`
  border-radius: 12px;
`;

export const Ambassadors = () => {
  const { formatMessage } = useIntl();
  return (
    <Vertical gap={2}>
      <TextWithLine>
        <FormattedMessage defaultMessage="Sorare Partners & Investors" />
      </TextWithLine>
      <Pictures>
        <picture>
          <source srcSet={rfAvif} type="image/avif" />
          <Image
            src={rf}
            alt={formatMessage({
              defaultMessage: 'Rio Ferdinand, Sorare investor',
            })}
            width="368"
            height="532"
            fetchPriority="low"
          />
        </picture>
        <picture>
          <source srcSet={kmAvif} type="image/avif" />
          <Image
            src={km}
            alt={formatMessage({
              defaultMessage: 'Kylian Mbappé, Sorare ambassador',
            })}
            width="368"
            height="532"
            fetchPriority="low"
          />
        </picture>
        <picture>
          <source srcSet={gpAvif} type="image/avif" />
          <Image
            src={gp}
            alt={formatMessage({
              defaultMessage: 'Gerard Piqué, Sorare investor',
            })}
            width="368"
            height="532"
            fetchPriority="low"
          />
        </picture>
      </Pictures>
    </Vertical>
  );
};
